import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface SearchState {
  newMessage: string
  messages: string
  contacts: string
  calls: string
  voicemails: string
  keypad: string
}

const initialState: SearchState = {
  newMessage: "",
  messages: "",
  contacts: "",
  calls: "",
  voicemails: "",
  keypad: ""
}

export const sliceKey = "searchKey"

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchedValue: (
      state,
      action: PayloadAction<{ category: keyof SearchState; value: string }>
    ) => {
      const { category, value } = action.payload
      state[category] = value
    },
    clearSearchedValue: (state, action: PayloadAction<keyof SearchState>) => {
      const category = action.payload
      state[category] = ""
    },
    clearAllSearchedValues: (state) => {
      state.messages = ""
      state.newMessage = ""
      state.contacts = ""
      state.calls = ""
      state.voicemails = ""
      state.keypad = ""
    }
  }
})

export const { setSearchedValue, clearSearchedValue, clearAllSearchedValues } =
  searchSlice.actions
export default searchSlice.reducer
